export default {
  _notes:
    'When adding new keys, please make sure they are also added to the `forms` translation domain',
  list: [
    { slug: 'afghan', name: 'Afghan', code: 'AFG' },
    { slug: 'albanian', name: 'Albanian', code: 'ALB' },
    { slug: 'algerian', name: 'Algerian', code: 'DZA' },
    { slug: 'american', name: 'American', code: 'USA' },
    { slug: 'andorran', name: 'Andorran', code: 'AND' },
    { slug: 'angolan', name: 'Angolan', code: 'AGO' },
    { slug: 'antiguans', name: 'Antiguans', code: 'ATG' },
    { slug: 'argentinean', name: 'Argentinean', code: 'ARG' },
    { slug: 'armenian', name: 'Armenian', code: 'ARM' },
    { slug: 'australian', name: 'Australian', code: 'AUS' },
    { slug: 'austrian', name: 'Austrian', code: 'AUT' },
    { slug: 'azerbaijani', name: 'Azerbaijani', code: 'AZE' },
    { slug: 'bahamian', name: 'Bahamian', code: 'BHS' },
    { slug: 'bahraini', name: 'Bahraini', code: 'BHR' },
    { slug: 'bangladeshi', name: 'Bangladeshi', code: 'BGD' },
    { slug: 'barbadian', name: 'Barbadian', code: 'BRB' },
    { slug: 'barbudans', name: 'Barbudans', code: 'ATG' },
    { slug: 'batswana', name: 'Batswana', code: 'BWA' },
    { slug: 'belarusian', name: 'Belarusian', code: 'BLR' },
    { slug: 'belgian', name: 'Belgian', code: 'BEL' },
    { slug: 'belizean', name: 'Belizean', code: 'BLZ' },
    { slug: 'beninese', name: 'Beninese', code: 'BEN' },
    { slug: 'bhutanese', name: 'Bhutanese', code: 'BTN' },
    { slug: 'bolivian', name: 'Bolivian', code: 'BOL' },
    { slug: 'bosnian', name: 'Bosnian', code: 'BIH' },
    { slug: 'brazilian', name: 'Brazilian', code: 'BRA' },
    { slug: 'british', name: 'British', code: 'GBR' },
    { slug: 'bruneian', name: 'Bruneian', code: 'BRN' },
    { slug: 'bulgarian', name: 'Bulgarian', code: 'BGR' },
    { slug: 'burkinabe', name: 'Burkinabe', code: 'BFA' },
    { slug: 'burmese', name: 'Burmese', code: 'MMR' },
    { slug: 'burundian', name: 'Burundian', code: 'BDI' },
    { slug: 'cambodian', name: 'Cambodian', code: 'KHM' },
    { slug: 'cameroonian', name: 'Cameroonian', code: 'CMR' },
    { slug: 'canadian', name: 'Canadian', code: 'CAN' },
    { slug: 'cape_verdean', name: 'Cape Verdean', code: 'CPV' },
    { slug: 'central_african', name: 'Central African', code: 'CAF' },
    { slug: 'chadian', name: 'Chadian', code: 'TCD' },
    { slug: 'chilean', name: 'Chilean', code: 'CHL' },
    { slug: 'chinese', name: 'Chinese', code: 'CHN' },
    { slug: 'colombian', name: 'Colombian', code: 'COL' },
    { slug: 'comoran', name: 'Comoran', code: 'COM' },
    { slug: 'congolese', name: 'Congolese', code: 'COD' },
    { slug: 'costa_rican', name: 'Costa Rican', code: 'CRI' },
    { slug: 'croatian', name: 'Croatian', code: 'HRV' },
    { slug: 'cuban', name: 'Cuban', code: 'CUB' },
    { slug: 'cypriot', name: 'Cypriot', code: 'CYP' },
    { slug: 'czech', name: 'Czech', code: 'CZE' },
    { slug: 'danish', name: 'Danish', code: 'DNK' },
    { slug: 'djibouti', name: 'Djibouti', code: 'DJI' },
    { slug: 'dominican', name: 'Dominican', code: 'DOM' },
    { slug: 'dutch', name: 'Dutch', code: 'NLD' },
    { slug: 'east_timorese', name: 'East Timorese', code: 'TLS' },
    { slug: 'ecuadorean', name: 'Ecuadorean', code: 'ECU' },
    { slug: 'egyptian', name: 'Egyptian', code: 'EGY' },
    { slug: 'emirian', name: 'Emirian', code: 'ARE' },
    { slug: 'equatorial_guinean', name: 'Equatorial Guinean', code: 'GNQ' },
    { slug: 'eritrean', name: 'Eritrean', code: 'ERI' },
    { slug: 'estonian', name: 'Estonian', code: 'EST' },
    { slug: 'ethiopian', name: 'Ethiopian', code: 'ETH' },
    { slug: 'fijian', name: 'Fijian', code: 'FJI' },
    { slug: 'filipino', name: 'Filipino', code: 'PHL' },
    { slug: 'finnish', name: 'Finnish', code: 'FIN' },
    { slug: 'french', name: 'French', code: 'FRA' },
    { slug: 'gabonese', name: 'Gabonese', code: 'GAB' },
    { slug: 'gambian', name: 'Gambian', code: 'GMB' },
    { slug: 'georgian', name: 'Georgian', code: 'GEO' },
    { slug: 'german', name: 'German', code: 'DEU' },
    { slug: 'ghanaian', name: 'Ghanaian', code: 'GHA' },
    { slug: 'greek', name: 'Greek', code: 'GRC' },
    { slug: 'grenadian', name: 'Grenadian', code: 'GRD' },
    { slug: 'guatemalan', name: 'Guatemalan', code: 'GTM' },
    { slug: 'guinea_bissauan', name: 'Guinea-Bissauan', code: 'GNB' },
    { slug: 'guinean', name: 'Guinean', code: 'GIN' },
    { slug: 'guyanese', name: 'Guyanese', code: 'GUY' },
    { slug: 'haitian', name: 'Haitian', code: 'HTI' },
    { slug: 'herzegovinian', name: 'Herzegovinian', code: 'BIH' },
    { slug: 'honduran', name: 'Honduran', code: 'HND' },
    { slug: 'hong_kong_sar', name: 'Hong Kong SAR', code: 'HKG' },
    { slug: 'hungarian', name: 'Hungarian', code: 'HUN' },
    { slug: 'i_kiribati', name: 'I-Kiribati', code: 'KIR' },
    { slug: 'icelander', name: 'Icelander', code: 'ISL' },
    { slug: 'indian', name: 'Indian', code: 'IND' },
    { slug: 'indonesian', name: 'Indonesian', code: 'IDN' },
    { slug: 'iranian', name: 'Iranian', code: 'IRN' },
    { slug: 'iraqi', name: 'Iraqi', code: 'IRQ' },
    { slug: 'irish', name: 'Irish', code: 'IRL' },
    { slug: 'israeli', name: 'Israeli', code: 'ISR' },
    { slug: 'italian', name: 'Italian', code: 'ITA' },
    { slug: 'ivorian', name: 'Ivorian', code: 'CIV' },
    { slug: 'jamaican', name: 'Jamaican', code: 'JAM' },
    { slug: 'japanese', name: 'Japanese', code: 'JPN' },
    { slug: 'jordanian', name: 'Jordanian', code: 'JOR' },
    { slug: 'kazakhstani', name: 'Kazakhstani', code: 'KAZ' },
    { slug: 'kenyan', name: 'Kenyan', code: 'KEN' },
    { slug: 'kittian_and_nevisian', name: 'Kittian and Nevisian', code: 'KNA' },
    { slug: 'kuwaiti', name: 'Kuwaiti', code: 'KWT' },
    { slug: 'kyrgyz', name: 'Kyrgyz', code: 'KGZ' },
    { slug: 'laotian', name: 'Laotian', code: 'LAO' },
    { slug: 'latvian', name: 'Latvian', code: 'LVA' },
    { slug: 'lebanese', name: 'Lebanese', code: 'LBN' },
    { slug: 'liberian', name: 'Liberian', code: 'LBR' },
    { slug: 'libyan', name: 'Libyan', code: 'LBY' },
    { slug: 'liechtensteiner', name: 'Liechtensteiner', code: 'LIE' },
    { slug: 'lithuanian', name: 'Lithuanian', code: 'LTU' },
    { slug: 'luxembourger', name: 'Luxembourger', code: 'LUX' },
    { slug: 'macau_sar', name: 'Macau SAR', code: 'MAC' },
    { slug: 'macedonian', name: 'Macedonian', code: 'MKD' },
    { slug: 'malagasy', name: 'Malagasy', code: 'MDG' },
    { slug: 'malawian', name: 'Malawian', code: 'MWI' },
    { slug: 'malaysian', name: 'Malaysian', code: 'MYS' },
    { slug: 'maldivan', name: 'Maldivan', code: 'MDV' },
    { slug: 'malian', name: 'Malian', code: 'MLI' },
    { slug: 'maltese', name: 'Maltese', code: 'MLT' },
    { slug: 'marshallese', name: 'Marshallese', code: 'MHL' },
    { slug: 'mauritanian', name: 'Mauritanian', code: 'MRT' },
    { slug: 'mauritian', name: 'Mauritian', code: 'MUS' },
    { slug: 'mexican', name: 'Mexican', code: 'MEX' },
    { slug: 'micronesian', name: 'Micronesian', code: 'FSM' },
    { slug: 'moldovan', name: 'Moldovan', code: 'MDA' },
    { slug: 'monacan', name: 'Monacan', code: 'MCO' },
    { slug: 'mongolian', name: 'Mongolian', code: 'MNG' },
    { slug: 'moroccan', name: 'Moroccan', code: 'MAR' },
    { slug: 'mosotho', name: 'Mosotho', code: 'LSO' },
    { slug: 'motswana', name: 'Motswana', code: 'BWA' },
    { slug: 'mozambican', name: 'Mozambican', code: 'MOZ' },
    { slug: 'namibian', name: 'Namibian', code: 'NAM' },
    { slug: 'nauruan', name: 'Nauruan', code: 'NRU' },
    { slug: 'nepalese', name: 'Nepalese', code: 'NPL' },
    { slug: 'netherlander', name: 'Netherlander', code: 'NLD' },
    { slug: 'new_zealander', name: 'New Zealander', code: 'NZL' },
    { slug: 'ni_vanuatu', name: 'Ni-Vanuatu', code: 'VUT' },
    { slug: 'nicaraguan', name: 'Nicaraguan', code: 'NIC' },
    { slug: 'nigerian', name: 'Nigerian', code: 'NGA' },
    { slug: 'nigerien', name: 'Nigerien', code: 'NGA' },
    { slug: 'north_korean', name: 'North Korean', code: 'PRK' },
    { slug: 'northern_irish', name: 'Northern Irish', code: 'GBR' },
    { slug: 'norwegian', name: 'Norwegian', code: 'NOR' },
    { slug: 'omani', name: 'Omani', code: 'OMN' },
    { slug: 'pakistani', name: 'Pakistani', code: 'PAK' },
    { slug: 'palauan', name: 'Palauan', code: 'PLW' },
    { slug: 'palestinian', name: 'Palestinian', code: 'PSE' },
    { slug: 'panamanian', name: 'Panamanian', code: 'PAN' },
    { slug: 'papua_new_guinean', name: 'Papua New Guinean', code: 'PNG' },
    { slug: 'paraguayan', name: 'Paraguayan', code: 'PRY' },
    { slug: 'peruvian', name: 'Peruvian', code: 'PER' },
    { slug: 'polish', name: 'Polish', code: 'POL' },
    { slug: 'portuguese', name: 'Portuguese', code: 'PRT' },
    { slug: 'qatari', name: 'Qatari', code: 'QAT' },
    { slug: 'romanian', name: 'Romanian', code: 'ROU' },
    { slug: 'russian', name: 'Russian', code: 'RUS' },
    { slug: 'rwandan', name: 'Rwandan', code: 'RWA' },
    { slug: 'saint_lucian', name: 'Saint Lucian', code: 'LCA' },
    { slug: 'salvadoran', name: 'Salvadoran', code: 'SLV' },
    { slug: 'samoan', name: 'Samoan', code: 'WSM' },
    { slug: 'san_marinese', name: 'San Marinese', code: 'SMR' },
    { slug: 'sao_tomean', name: 'Sao Tomean', code: 'STP' },
    { slug: 'saudi', name: 'Saudi', code: 'SAU' },
    { slug: 'scottish', name: 'Scottish', code: 'GBR' },
    { slug: 'senegalese', name: 'Senegalese', code: 'SEN' },
    { slug: 'serbian', name: 'Serbian', code: 'SRB' },
    { slug: 'seychellois', name: 'Seychellois', code: 'SYC' },
    { slug: 'sierra_leonean', name: 'Sierra Leonean', code: 'SLE' },
    { slug: 'singaporean', name: 'Singaporean', code: 'SGP' },
    { slug: 'slovakian', name: 'Slovakian', code: 'SVK' },
    { slug: 'slovenian', name: 'Slovenian', code: 'SVN' },
    { slug: 'solomon_islander', name: 'Solomon Islander', code: 'SLB' },
    { slug: 'somali', name: 'Somali', code: 'SOM' },
    { slug: 'south_african', name: 'South African', code: 'ZAF' },
    { slug: 'south_korean', name: 'South Korean', code: 'KOR' },
    { slug: 'spanish', name: 'Spanish', code: 'ESP' },
    { slug: 'sri_lankan', name: 'Sri Lankan', code: 'LKA' },
    { slug: 'sudanese', name: 'Sudanese', code: 'SDN' },
    { slug: 'surinamer', name: 'Surinamer', code: 'SUR' },
    { slug: 'swazi', name: 'Swazi', code: 'SWZ' },
    { slug: 'swedish', name: 'Swedish', code: 'SWE' },
    { slug: 'swiss', name: 'Swiss', code: 'CHE' },
    { slug: 'syrian', name: 'Syrian', code: 'SYR' },
    { slug: 'taiwanese', name: 'Taiwanese', code: 'TWN' },
    { slug: 'tajik', name: 'Tajik', code: 'TJK' },
    { slug: 'tanzanian', name: 'Tanzanian', code: 'TZA' },
    { slug: 'thai', name: 'Thai', code: 'THA' },
    { slug: 'togolese', name: 'Togolese', code: 'TGO' },
    { slug: 'tongan', name: 'Tongan', code: 'TON' },
    { slug: 'trinidadian_or_tobagonian', name: 'Trinidadian or Tobagonian', code: 'TTO' },
    { slug: 'tunisian', name: 'Tunisian', code: 'TUN' },
    { slug: 'turkish', name: 'Turkish', code: 'TUR' },
    { slug: 'tuvaluan', name: 'Tuvaluan', code: 'TUV' },
    { slug: 'ugandan', name: 'Ugandan', code: 'UGA' },
    { slug: 'ukrainian', name: 'Ukrainian', code: 'UKR' },
    { slug: 'uruguayan', name: 'Uruguayan', code: 'URY' },
    { slug: 'uzbekistani', name: 'Uzbekistani', code: 'UZB' },
    { slug: 'venezuelan', name: 'Venezuelan', code: 'VEN' },
    { slug: 'vietnamese', name: 'Vietnamese', code: 'VNM' },
    { slug: 'welsh', name: 'Welsh', code: 'GBR' },
    { slug: 'yemenite', name: 'Yemenite', code: 'YEM' },
    { slug: 'zambian', name: 'Zambian', code: 'ZMB' },
    { slug: 'zimbabwean', name: 'Zimbabwean', code: 'ZWE' },
  ],
};
